import {BASE_URL} from "../../config/network";
import {resolveWhiteLabelSubsidiaryId} from "../../config/subsidiaryId";

const getCustomersAPI = async ({authToken, subsidiaryId}) => {
    const requestSubsidiaryId = resolveWhiteLabelSubsidiaryId(subsidiaryId);

    const URL = `${BASE_URL}/${requestSubsidiaryId}/client/customers`
    const METHOD = "GET"
    const HEADERS = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
    }

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS,
    })

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`)
    }

    return await response.json()
}

export {getCustomersAPI}
